// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3xbid","logo":"Header_logo__dIQiB","logout":"Header_logout__1tFbn"};